import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ name: "", email: "", password: "" });
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        setBusy(true); setErr("");
        try {
            await register(form);
            toast.success("Cuenta creada");
            navigate("/dashboard");
        } catch (e2) {
            setErr(formatApiError(e2.response?.data?.detail) || e2.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
            <form onSubmit={onSubmit} className="w-full max-w-md bg-white rounded-lg border border-slate-200 p-8 space-y-6" data-testid="register-form">
                <div>
                    <h1 className="font-display text-2xl font-semibold tracking-tight">Crear cuenta</h1>
                    <p className="text-sm text-slate-500 mt-1">Empieza a usar Emprenovus CRM</p>
                </div>
                <div className="space-y-3">
                    <div>
                        <Label htmlFor="name">Nombre</Label>
                        <Input id="name" data-testid="register-name-input" required value={form.name} onChange={(e)=>setForm({...form, name: e.target.value})} />
                    </div>
                    <div>
                        <Label htmlFor="email">Correo</Label>
                        <Input id="email" data-testid="register-email-input" type="email" required value={form.email} onChange={(e)=>setForm({...form, email: e.target.value})} />
                    </div>
                    <div>
                        <Label htmlFor="password">Contraseña</Label>
                        <Input id="password" data-testid="register-password-input" type="password" required minLength={6} value={form.password} onChange={(e)=>setForm({...form, password: e.target.value})} />
                    </div>
                </div>
                {err && <div className="text-sm text-red-600">{err}</div>}
                <Button type="submit" className="w-full" disabled={busy} data-testid="register-submit-button">{busy ? "Creando..." : "Crear cuenta"}</Button>
                <div className="text-sm text-slate-500 text-center">¿Ya tienes cuenta? <Link to="/login" className="text-orange-600 font-medium">Iniciar sesión</Link></div>
            </form>
        </div>
    );
}
